// Docs: IMPLEMENTATION.md §3.4 (navigation components).
// Shared SVG nav icon set for the Coach tab bar and the Studio rail —
// replaces the old Unicode glyphs (☐ ▦ ◇ …) which rendered inconsistently
// across platforms. Same visual language as AudioIcons.jsx: 24px viewBox,
// stroke 1.8, square caps (Bauhaus hard edges).
import React from 'react';

const base = (size) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  'aria-hidden': true,
});

const ICONS = {
  // heute — day sheet
  heute: (
    <>
      <rect x="4" y="4" width="16" height="16" />
      <path d="M4 9h16" />
    </>
  ),
  // wörter / bibliothek — grid of cells
  woerter: (
    <>
      <rect x="4" y="4" width="16" height="16" />
      <path d="M4 9.3h16M4 14.6h16M9.3 4v16M14.6 4v16" />
    </>
  ),
  // üben — target
  ueben: (
    <>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="3" fill="currentColor" stroke="none" />
    </>
  ),
  // entdecken — spark / peaks
  entdecken: <path d="M5 12l4-8 4 8 4-8 2 16H5z" />,
  // statistik — bars
  statistik: <path d="M5 19V11M10 19V5M15 19v-8M20 19V8" />,
  // profil — person
  profil: (
    <>
      <circle cx="12" cy="8.5" r="3.5" />
      <path d="M5 19c1.5-3.2 4-4.5 7-4.5s5.5 1.3 7 4.5" />
    </>
  ),
  // einstellungen — hex nut
  einstellungen: (
    <>
      <path d="M12 3l7.8 4.5v9L12 21l-7.8-4.5v-9z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  play: <path d="M7 4.5v15l13-7.5z" fill="currentColor" stroke="none" />,
  kalender: (
    <>
      <rect x="4" y="5" width="16" height="15" />
      <path d="M4 10h16M8 3v4M16 3v4" />
    </>
  ),
  check: <path d="m5 13 4.2 4.2L19 7" strokeWidth="2.4" />,
  suche: (
    <>
      <circle cx="10.5" cy="10.5" r="6.5" />
      <path d="m20 20-4.8-4.8" />
    </>
  ),
  einklappen: <path d="m14 6-6 6 6 6" />,
  ausklappen: <path d="m10 6 6 6-6 6" />,
};

const NavIcon = ({ name, size = 19, className }) => {
  const shape = ICONS[name];
  if (!shape) return null;
  return (
    <svg {...base(size)} className={className}>
      {shape}
    </svg>
  );
};

export default NavIcon;
